import {
  CREATE_TOP_UP_IBAN_FAILURE,
  CREATE_TOP_UP_IBAN_STARTED,
  CREATE_TOP_UP_IBAN_SUCCESS,
  DELETE_TOP_UP_IBAN_FAILURE,
  DELETE_TOP_UP_IBAN_STARTED,
  DELETE_TOP_UP_IBAN_SUCCESS,
  GET_AGENT_TOP_UP_LIST_STARTED,
  GET_AGENT_TOP_UP_LIST_SUCCESS,
  GET_AGENT_TOP_UP_LIST_FAILURE,
  GET_TOP_UP_BANKS_FAILURE,
  GET_TOP_UP_BANKS_STARTED,
  GET_TOP_UP_BANKS_SUCCESS,
  GET_TOP_UP_COUNTRIES_FAILURE,
  GET_TOP_UP_COUNTRIES_STARTED,
  GET_TOP_UP_COUNTRIES_SUCCESS,
  GET_TOP_UP_IBAN_LIST_FAILURE,
  GET_TOP_UP_IBAN_LIST_STARTED,
  GET_TOP_UP_IBAN_LIST_SUCCESS,
  GET_TOP_UP_LIST_FAILURE,
  GET_TOP_UP_LIST_STARTED,
  GET_TOP_UP_LIST_SUCCESS,
  GET_TOP_UP_CARD_LIST_STARTED,
  GET_TOP_UP_CARD_LIST_SUCCESS,
  GET_TOP_UP_CARD_LIST_FAILURE,
  EDIT_CURENCY_SPREAD_STARTED,
  EDIT_CURENCY_SPREAD_SUCCESS,
  EDIT_CURENCY_SPREAD_FAILURE,
  GET_CURENCY_SPREAD_TYPES_STARTED,
  GET_CURENCY_SPREAD_TYPES_SUCCESS,
  GET_CURENCY_SPREAD_TYPES_FAILURE,
} from "redux/ActionTypes";
import {
  createTopUpIbanAPI,
  deleteTopUpIbanAPI,
  editCurrencySpreadAPI,
  getAgentTopUpListAPI,
  getCurrencySpreadTypesAPI,
  getTopUpBanksAPI,
  getTopUpCardListAPI,
  getTopUpCountriesAPI,
  getTopUpIbanListAPI,
  getTopUpListAPI,
} from "services/API/topup";
// --------------------------------------------------------------------------------
export const getTopUpListRequestAction = ({
  limit,
  offset,
  from,
  to,
  agent,
  currency,
}) => {
  return async (dispatch) => {
    dispatch(getTopUpListStartedAction());
    try {
      let response = await getTopUpListAPI({
        limit,
        offset,
        from,
        to,
        agent,
        currency,
      });
      if (!response.error) {
        dispatch(getTopUpListSuccessAction({ topUpList: response.data }));
      } else {
        dispatch(getTopUpListFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(getTopUpListFailureAction(error.error_description));
    }
  };
};

export const getTopUpListStartedAction = () => ({
  type: GET_TOP_UP_LIST_STARTED,
});

export const getTopUpListSuccessAction = (payload) => ({
  type: GET_TOP_UP_LIST_SUCCESS,
  payload,
});

export const getTopUpListFailureAction = (message) => ({
  type: GET_TOP_UP_LIST_FAILURE,
  payload: message,
});

// --------------------------------------------------------------------------------
export const getTopUpCardListRequestAction = ({
  limit,
  offset,
  from,
  to,
  agent,
  currency,
}) => {
  return async (dispatch) => {
    dispatch(getTopUpCardListStartedAction());
    try {
      let response = await getTopUpCardListAPI({
        limit,
        offset,
        from,
        to,
        agent,
        currency,
      });
      if (!response.error) {
        dispatch(
          getTopUpCardListSuccessAction({ topUpCardList: response.data })
        );
      } else {
        dispatch(
          getTopUpCardListFailureAction(response.data.error_description)
        );
      }
    } catch (error) {
      dispatch(getTopUpCardListFailureAction(error.error_description));
    }
  };
};

export const getTopUpCardListStartedAction = () => ({
  type: GET_TOP_UP_CARD_LIST_STARTED,
});

export const getTopUpCardListSuccessAction = (payload) => ({
  type: GET_TOP_UP_CARD_LIST_SUCCESS,
  payload,
});

export const getTopUpCardListFailureAction = (message) => ({
  type: GET_TOP_UP_CARD_LIST_FAILURE,
  payload: message,
});

// --------------------------------------------------------------------------------
export const getTopUpAgentListRequestAction = () => {
  return async (dispatch) => {
    dispatch(getTopUpAgentListStartedAction());
    try {
      let response = await getAgentTopUpListAPI();
      console.log(response);
      if (!response.error) {
        dispatch(
          getTopUpAgentListSuccessAction({ agentTopUpList: response.data })
        );
      } else {
        dispatch(getTopUpListFailureAction(response.data.error_description));
      }
    } catch (error) {
      dispatch(getTopUpAgentListFailureAction(error.error_description));
    }
  };
};

export const getTopUpAgentListStartedAction = () => ({
  type: GET_AGENT_TOP_UP_LIST_STARTED,
});

export const getTopUpAgentListSuccessAction = (payload) => ({
  type: GET_AGENT_TOP_UP_LIST_SUCCESS,
  payload,
});

export const getTopUpAgentListFailureAction = (message) => ({
  type: GET_AGENT_TOP_UP_LIST_FAILURE,
  payload: message,
});

// --------------------------------------------------------------------------------
export const getTopUpCountriesAction = ({ walletId }) => {
  return async (dispatch) => {
    dispatch(getTopUpCountriesStartedAction());
    try {
      let response = await getTopUpCountriesAPI({ walletId });
      if (response.status === "success") {
        dispatch(
          getTopUpCountriesSuccessAction({ topUpCountries: response.data })
        );
      } else {
        getTopUpCountriesFailureAction(response.data.error_description);
      }
    } catch (error) {
      dispatch(getTopUpCountriesFailureAction(error.error_description));
    }
  };
};

export const getTopUpCountriesStartedAction = () => ({
  type: GET_TOP_UP_COUNTRIES_STARTED,
});

export const getTopUpCountriesSuccessAction = (payload) => ({
  type: GET_TOP_UP_COUNTRIES_SUCCESS,
  payload,
});

export const getTopUpCountriesFailureAction = (message) => ({
  type: GET_TOP_UP_COUNTRIES_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getTopUpBanksAction = ({ countryId }) => {
  return async (dispatch) => {
    dispatch(getTopUpBanksStartedAction());
    try {
      let response = await getTopUpBanksAPI({ countryId });
      if (response.status === "success") {
        dispatch(getTopUpBanksSuccessAction({ topUpBanks: response.data }));
      } else {
        getTopUpBanksFailureAction(response.data.error_description);
      }
    } catch (error) {
      dispatch(getTopUpBanksFailureAction(error.error_description));
    }
  };
};

export const getTopUpBanksStartedAction = () => ({
  type: GET_TOP_UP_BANKS_STARTED,
});

export const getTopUpBanksSuccessAction = (payload) => ({
  type: GET_TOP_UP_BANKS_SUCCESS,
  payload,
});

export const getTopUpBanksFailureAction = (message) => ({
  type: GET_TOP_UP_BANKS_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const createTopUpIbanAction = ({
  currencyId,
  countryName,
  bankName,
  iban,
  holderName,
  onSuccess,
  setLoading,
}) => {
  return async (dispatch) => {
    dispatch(createTopUpIbanStartedAction());
    setLoading(true);
    try {
      let response = await createTopUpIbanAPI({
        currencyId,
        countryName,
        bankName,
        holderName,
        iban,
      });
      if (response.status === "success") {
        dispatch(createTopUpIbanSuccessAction({ topUpBanks: response.data }));
        setLoading(false);
        onSuccess();
      } else {
        setLoading(false);
        createTopUpIbanFailureAction(response.data.error_description);
      }
    } catch (error) {
      setLoading(false);
      dispatch(createTopUpIbanFailureAction(error.error_description));
    }
  };
};

export const createTopUpIbanStartedAction = () => ({
  type: CREATE_TOP_UP_IBAN_STARTED,
});

export const createTopUpIbanSuccessAction = (payload) => ({
  type: CREATE_TOP_UP_IBAN_SUCCESS,
  payload,
});

export const createTopUpIbanFailureAction = (message) => ({
  type: CREATE_TOP_UP_IBAN_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getTopUpIbanListAction = () => {
  return async (dispatch) => {
    dispatch(getTopUpIbanListStartedAction());
    try {
      let response = await getTopUpIbanListAPI();
      if (response.status === "success") {
        dispatch(getTopUpIbanListSuccessAction({ ibanList: response.data }));
      } else {
        getTopUpIbanListFailureAction(response.data.error_description);
      }
    } catch (error) {
      dispatch(getTopUpIbanListFailureAction(error.error_description));
    }
  };
};

export const getTopUpIbanListStartedAction = () => ({
  type: GET_TOP_UP_IBAN_LIST_STARTED,
});

export const getTopUpIbanListSuccessAction = (payload) => ({
  type: GET_TOP_UP_IBAN_LIST_SUCCESS,
  payload,
});

export const getTopUpIbanListFailureAction = (message) => ({
  type: GET_TOP_UP_IBAN_LIST_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const deleteTopUpIbanAction = ({ id }) => {
  return async (dispatch) => {
    dispatch(deleteTopUpIbanStartedAction());
    try {
      let response = await deleteTopUpIbanAPI({ id });
      if (response.status === "success") {
        dispatch(deleteTopUpIbanSuccessAction());
        dispatch(getTopUpIbanListAction());
      } else {
        deleteTopUpIbanFailureAction(response.data.error_description);
      }
    } catch (error) {
      dispatch(deleteTopUpIbanFailureAction(error.error_description));
    }
  };
};

export const deleteTopUpIbanStartedAction = () => ({
  type: DELETE_TOP_UP_IBAN_STARTED,
});

export const deleteTopUpIbanSuccessAction = (payload) => ({
  type: DELETE_TOP_UP_IBAN_SUCCESS,
  payload,
});

export const deleteTopUpIbanFailureAction = (message) => ({
  type: DELETE_TOP_UP_IBAN_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const editCurrencySpreadAction = ({
  currencyId,
  spread,
  type,
  onSuccess,
}) => {
  return async (dispatch) => {
    dispatch(editCurrencySpreadStartedAction());
    try {
      let response = await editCurrencySpreadAPI({ currencyId, spread, type });
      if (response.status) {
        onSuccess();
        dispatch(editCurrencySpreadSuccessAction());
      } else {
        editCurrencySpreadFailureAction(response.data.error_description);
      }
    } catch (error) {
      dispatch(editCurrencySpreadFailureAction(error.error_description));
    }
  };
};

export const editCurrencySpreadStartedAction = () => ({
  type: EDIT_CURENCY_SPREAD_STARTED,
});

export const editCurrencySpreadSuccessAction = () => ({
  type: EDIT_CURENCY_SPREAD_SUCCESS,
});

export const editCurrencySpreadFailureAction = (message) => ({
  type: EDIT_CURENCY_SPREAD_FAILURE,
  payload: message,
});
// --------------------------------------------------------------------------------
export const getCurrencySpreadTypesAction = () => {
  return async (dispatch) => {
    dispatch(getCurrencySpreadTypesStartedAction());
    try {
      let response = await getCurrencySpreadTypesAPI();
      if (response.status) {
        dispatch(
          getCurrencySpreadTypesSuccessAction({
            currencySpreadTypes: response.data,
          })
        );
      } else {
        getCurrencySpreadTypesFailureAction(response.data.error_description);
      }
    } catch (error) {
      dispatch(getCurrencySpreadTypesFailureAction(error.error_description));
    }
  };
};

export const getCurrencySpreadTypesStartedAction = () => ({
  type: GET_CURENCY_SPREAD_TYPES_STARTED,
});

export const getCurrencySpreadTypesSuccessAction = (payload) => ({
  type: GET_CURENCY_SPREAD_TYPES_SUCCESS,
  payload,
});

export const getCurrencySpreadTypesFailureAction = (message) => ({
  type: GET_CURENCY_SPREAD_TYPES_FAILURE,
  payload: message,
});
